<template>
  <div id="membersRecord">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item
          label="完成状态"
          label-width="100px"
        >
          <el-select
            v-model="formInline.FinishState"
            placeholder="请选择完成状态"
            @change="handleCurrentChange(1)"
          >
            <el-option
              v-for="item in FinishStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        :height="tableH"
        :data="recordList"
        border
        style="width: 100%"
      >
        <el-table-column
          header-align="center"
          prop="qusetionnaireTitle"
          label="问卷名称 "
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="完成状态"
        >
          <template slot-scope="scope">
            <template v-for="(item,index) in FinishStateList">
              <span
                :key="index"
                :style="{color:item.color}"
                v-if="item.value==scope.row.finishState"
              >{{ item.label}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receivePrice"
          label="理论报酬 "
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actualPrice"
          label="实际报酬 "
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareUserName"
          label="分享人 "
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="创建时间"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime?scope.row.createTime.slice(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="完成时间"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.finishTime?scope.row.finishTime.slice(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="是否已提现"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.hasRecieve?'已提现':'未提现'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="提现时间"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.recieveTime?scope.row.recieveTime.slice(0,10):''}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getRecords } from 'api/request'
import { SetTableH } from '../../utils/utils'
export default {
  data() {
    return {
      tableH: '250',
      dialogVisible: false,
      dataObj: null,
      formInline: {
        FinishState: -1
      },
      pageObj: {
        total: 0,
        PageIndex: 1,
        PageSize: 10
      },
      FinishStateList: [
        {
          value: -1,
          label: '全部',
          color: ''
        },
        {
          value: 0,
          label: '未完成',
          color: ''
        },
        {
          value: 1,
          label: '被甄别',
          color: ''
        },
        {
          value: 2,
          label: '完成',
          color: ''
        }
      ],
      recordList: []
    }
  },
  components: {},
  methods: {
    handleSizeChange(val) {
      this.pageObj.PageSize = val
      this.getRecordDes()
    },
    handleCurrentChange(val) {
      this.pageObj.PageIndex = val
      this.getRecordDes()
    },
    async getRecordDes() {
      let params = {
        id: this.$route.query.id,
        searchParams: {
          PageIndex: this.pageObj.PageIndex,
          PageSize: this.pageObj.PageSize,
          FinishState: this.formInline.FinishState
        }
      }
      let data = await getRecords(params)
      if (data) {
        this.recordList = data.rows
        this.pageObj.total = data.total
      }
    }
  },
  mounted() {
    SetTableH(this)
  },
  created() {
    this.getRecordDes()
    console.log(this.recordList)
  }
}
</script>
<style lang='scss'>
#membersRecord {
  height: 100%;
  width: 100%;
  .formBox {
    width: 200px;
  }
  .pageBox {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
